import { Injectable, Inject, Injector, ReflectiveInjector } from '@angular/core';

import {NgbModal, NgbModalOptions, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

import { environment } from '../../environments/environment'
@Injectable({
  providedIn: 'root'
})

//const injector=Injector.create({providers: [{provide: mdService, deps: []}]})


export class InstiModalService {
         modal_instance:any; //NgbModal;
        private options:any={size:'xl', windowClass: 'modal-xl'};
        private content:any;
    constructor(
            modal:any
        ) { 
       this.setInstance(modal); 
    }
    
    getContent(){return this.content;}
    getOptions(){ return this.options;}
    getInstance(){ return this.modal_instance;}
    
    setContent(value):InstiModalService{
        this.content=value;
        return this;
    }
    setOptions(value):InstiModalService{ 
        this.options=value;
        return this;
    }
    setInstance(value):InstiModalService{ 
        
        this.modal_instance=value; //new NgbModal(null, Injector, new NgbModal());
        return this;
    }    
    
    open(handle?, event?):InstiModalService{
         var a=this.getInstance().open(this.getContent(), this.getOptions());
        /*    
          this.getInstance().then((result) => {
            return !handle? result : handle(result);
        }, 
        (reason) => {
            return !event ? reason : event(reason);
        });
        */
        return this;
    }

    dismissAll():InstiModalService{
        this.getInstance().dismissAll();
        return this;
    }
      
}
